import { useCallback, useState } from "react";

export const useKeyFnState = <T>(initValue: T, getKey: (v: T) => string = (v: T) => JSON.stringify(v)): [T, (_: T) => void] => {
  const [wrappedValue, setWrappedValue] = useState<T>(initValue);
  const [valueKey, setValueKey] = useState<string>(getKey(initValue));

  const updateValue = useCallback(
    (value: T) => {
      const paramValueKey = getKey(value);
      if (valueKey !== paramValueKey) {
        setValueKey(paramValueKey);
        setWrappedValue(value);
      }
    },
    [getKey, valueKey],
  );

  return [wrappedValue, updateValue];
};
